import { OfflineBookingPassengerDetails, OfflineBookingWrapper } from "./OfflineBookingProperties";


export class OfflineBookingRequest {
  offlineBookingRequestId: number = 0;
  offlineRequestTypeId: number = 0;
  requestStatusName: string = "";
  requestStatus: number = 0;
  tripType: number = 1;
  returnDate: Date = new Date();
  adult: number = 0;
  child: number = 0;
  infant: number = 0;
  cabinClass: string;
  fareType: string;
  airlineName: string;
  flightNo: string;
  creationUser: number = 0;
  creationUsername: string="";
  agencyBranchManagerId: number = 0;
  openByManager: boolean = false;
  agencyBranchId: string;
  parentHierarchy: string;
  departureDate: Date;
  sector: string;
  rejectionMessage: string = "";
  rbd: string = "";
  flightRoute: FlightRoute[] = [];
  passengerFares: string = "";
  bookingSource: string = "";
  bookingPcc: string = "";
  exchangeCurrencyRate:number=0;
}
//06-feb-24
export class FlightRoute {
  departureFrom: string;
  arrivalTo: string;
  departureDate: Date;
}
//end
export class OfflineBookingRequestObject {
  offlineBookingRequest = new OfflineBookingRequest();
  offlineBookingPassengers: OfflineBookingPassengerDetails[] = [];
}
export class ChatForm {
  offlineBookingRequestId: number = 0;
  userId: number = 0;
  message: string;
  fileAttached: File[]=[];
  isManager:boolean=false;
  managerId: number = 0;
  chatTime: string = "";
}
export class ChatMessages {
  id: number;
  offlineBookingRequestId: number;
  userName: string;
  message: string;
  userId: number;
  receivedFile: string[]=[];
  messageStatus: number = 0;
  chatTime: string = "";
}
export class ChatMessageAttachments {
  offlineBookingId: number = 0;
  userId: number = 0;
  filePath: string = "";
  messageId: number = 0;
}
export class ChatMessagesBase {
  chatMessages: ChatMessages[] = [];
  chatAttachments: ChatMessageAttachments[] = [];
 }
//10-June-24
export class OfflineBookingRequestGet {
  managerId: number = 0;
  offlineBookingRequestID: number = 0;
  statusOpen: boolean = false;
  agencyId:string="";
  userId:number=0;
}
//end

export class OfflineBookingResponseGet {
  offlineBookingRequest = new OfflineBookingRequest();
  chatMessages: ChatMessages[] = [];
  offlineBooking = new OfflineBookingWrapper();
  offlineBookingRequestPassengers: OfflineBookingPassengerDetails[] = [];
}
export class OfflineBookingMessageStatusUpdate {
  messageId: number = 0;
  messageStatus: number = 0;
  offlineBookingRequestId: number = 0;
  offlineBookingRequestStatus: number = 0;
}
export class OfflineBookingRejection {
  rejectionMessage: string;
  offlineBookingRequestId: number;
  requestStatus: number;
}
export class SuppliersCurrency {
  supplierCurrencyId: number;
  supplierCurrencyName: string;
}
export class OfflineBookingSuppliersAccessCodeProperties {
  codeId: number;
  supplierId: string;
  officeId: string;
  currencyId: number;

}
export class AgencySuppliers {
  agencyIds: string[] = [];
  supplier: string;
  pcc: string;
  canBook: boolean = false;
  canIssue: boolean = false;
  canRefund: boolean = false;
  canVoid: boolean = false;
  canSearch: boolean = false;
  status: boolean;
  creationUser: number;
  isDeleted: boolean;
}
